import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-input-group-suffix',
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputGroupSuffixComponent {
}
